module.exports = __webpack_public_path__ + "static/media/h2_who.e75e7e2b.webp";